export default {"src":"/_next/static/media/circularReebeloCare.134dd2d4.svg","height":51,"width":51};